import type { ThemeConfig } from 'antd';

// DomainsLK Figma — primary CTA #f37b1d
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#f37b1d',
    colorSuccess: '#16a34a',
    colorWarning: '#eab308',
    colorError: '#dc2626',
    colorTextBase: '#1e293b',
    colorBgBase: '#ffffff',
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
    controlHeightLG: 48,
    wireframe: false,
  },
  components: {
    Button: {
      borderRadiusLG: 9999,
      primaryShadow:
        '0 4px 6px -1px rgb(243 123 29 / 0.3), 0 2px 4px -2px rgb(243 123 29 / 0.3)',
    },
    Input: {
      borderRadiusLG: 12,
      fontFamily:
        "'Poppins', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      fontSize: 14,
    },
    Card: {
      borderRadiusLG: 16,
    },
  },
};
